import React from "react";
import { useNavigate } from "react-router-dom";
import "./StoreUnfulfilledOrders.css";
import { FaArrowLeft } from "react-icons/fa";

export default function StoreUnfulfilledOrders() {
  const navigate = useNavigate();

  return (
    <div className="store-simple-page">
      <button className="store-simple-back" onClick={() => navigate(-1)}>
        <FaArrowLeft />
      </button>
      <div className="store-simple-content">
        <h1>Unfulfilled Orders</h1>
        <p>This page will list all orders that still need your attention.</p>
      </div>
    </div>
  );
}


